import Cookies from "js-cookie";
import axios from "axios";
import store from "./store";

export default {
    fbPixelEvent(eventType, eventName, customData = {}, eventData = {}) {
        if (window.config.debug) return null;

        if (!eventType || !eventName) return null;

        // Get user data from Vuex store
        const userFormData = store.state.giftCardCart?.giftCardCartForm || {};

        const data = {
            eventName: eventName,
            customData: customData,
            eventData: eventData,
            fbp: Cookies.get("_fbp"),
            fbc: Cookies.get("_fbc"),

            // Send customer data if available (from previous checkout)
            email: userFormData.paymentEmail || null,
            phone: userFormData.paymentPhone || null,
            fn: userFormData.paymentFirstName || null,
            ln: userFormData.paymentLastName || null,
            ct: userFormData.paymentCity || null,
            zip: userFormData.paymentPostCode || null,
        };

        axios.post("/analytics/conversions-api", data).then((response) => {
            eventData.eventID = response.data.eventID;
            fbq(eventType, eventName, customData, eventData);
        });
    },

    gtmDataLayer(event, items = {}, additionalData = {}) {
        if (window.config.debug) return null;

        if (!event) return null;

        const data = {
            event: event,
            ecommerce: {
                ...additionalData,
                items: Array.isArray(items) ? items : [items],
            },
        };

        window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
        window.dataLayer.push(data);
    },
};
